import React from 'react';

function RecurranceUpdateInstancePopup({ handleClose, data, callback }) {
  const selectAction = (val) => {
    callback(val);
    handleClose();
  };
  return (
    <div>
      <div className="modalBackground">
        <div className="treatment-plan-container">
          <div className="treatment-plan-head">
            <span>
              {`${data?.statusTxt}: ${data?.resourceName} recurring blocks`}
            </span>
            <span className="treatment-plan-close" onClick={handleClose}>
              X
            </span>
          </div>
          <div className="treatment-plan-body med-common-bg">
            <div>
              <div>
                <span className="bold">Description: </span>
                <span>{data?.task_description}</span>
              </div>
              <div>
                <span className="bold">Time period: </span>
                <span>
                  {data?.task_start_time} To {data?.task_end_time}
                </span>
              </div>
            </div>
            <div className="treatment-plan-check">
              <b>
                Future appointments left in the series: {data?.recuFutBlockCnt}
              </b>
            </div>
            <div className="treatment-plan-check">
              <input
                type="radio"
                name="selectAction"
                onClick={() => selectAction('0')}
                style={{ marginRight: '10px' }}
              />
              This instance
            </div>
            <div className="treatment-plan-check">
              <input
                type="radio"
                name="selectAction"
                onClick={() => selectAction('1')}
                style={{ marginRight: '10px' }}
              />
              This &amp; all the future instances
            </div>
          </div>
          <div className="treatment-plan-foot">
            <span className="right button-submit" onClick={handleClose}>
              Close
              <p />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecurranceUpdateInstancePopup;
